import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ImageSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const slides = [
    {
      id: 1,
      image: "/Summary.png",
    },
    {
      id: 2,
      image: "/Red Flags.png",
    },
    {
      id: 3,
      image: "/Timesheet.png",
    },
    {
      id: 4,
      image: "/Hours in detail.png",
    },
    {
      id: 5,
      image: "/No Practice CS screen.jpg",
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto-play functionality - slowed down
  useEffect(() => {
    if (isAutoPlaying) {
      const interval = setInterval(() => {
        nextSlide();
      }, 6000); // Changed from 4000 to 6000 (6 seconds)

      return () => clearInterval(interval);
    }
  }, [isAutoPlaying, currentSlide]);

  return (
    <div className="relative">
      <div className="rounded-lg overflow-hidden bg-gray-50 border border-gray-200">
        <div className="relative h-[500px]">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`absolute inset-0 transition-all duration-700 ease-in-out ${
                index === currentSlide
                  ? 'opacity-100 transform translate-x-0'
                  : index < currentSlide
                  ? 'opacity-0 transform -translate-x-full'
                  : 'opacity-0 transform translate-x-full'
              }`}
            >
              <div className="h-full flex items-center justify-center p-6">
                <img
                  src={slide.image}
                  alt={`Practice Dashboard Screenshot ${index + 1}`}
                  className="max-h-full max-w-full object-contain rounded-lg shadow-xl"
                />
              </div>
            </div>
          ))}
        </div>
        
        {/* Navigation Buttons */}
        <button
          onClick={prevSlide}
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
          className="absolute left-6 top-1/2 transform -translate-y-1/2 bg-white/95 backdrop-blur-sm hover:bg-white rounded-full p-4 shadow-xl transition-all duration-200 z-20 border border-gray-200"
        >
          <ChevronLeft className="w-7 h-7 text-gray-700" />
        </button>
        
        <button
          onClick={nextSlide}
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
          className="absolute right-6 top-1/2 transform -translate-y-1/2 bg-white/95 backdrop-blur-sm hover:bg-white rounded-full p-4 shadow-xl transition-all duration-200 z-20 border border-gray-200"
        >
          <ChevronRight className="w-7 h-7 text-gray-700" />
        </button>
        
        {/* Slide Indicators */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              onMouseEnter={() => setIsAutoPlaying(false)}
              onMouseLeave={() => setIsAutoPlaying(true)}
              className={`w-4 h-4 rounded-full transition-all duration-300 border-2 ${
                index === currentSlide
                  ? 'bg-orange-500 border-orange-500 shadow-lg scale-110'
                  : 'bg-white border-gray-300 hover:border-gray-400'
              }`}
            />
          ))}
        </div>
      </div>
      
      <div className="text-center mt-6">
        <p className="text-gray-600 text-sm">Practice Dashboard Interface Examples</p>
      </div>
    </div>
  );
};

export default ImageSlider;